<template>
    <div class="content-line">
        <Card>
            <div class="condition-line">
                <div class="block">
                    <DatePicker></DatePicker>
                </div>
            </div>
        </Card>
    </div>
    <div class="content-line">
        <Card>
            <template v-slot:header>
                <h2>客流总览</h2>
                <span class="icon-info">&nbsp;</span>

                <div class="card-header-block">
                    <el-radio-group size="mini">
                        <el-radio-button label="7">近7天</el-radio-button>
                        <el-radio-button label="15">近15天</el-radio-button>
                        <el-radio-button label="30">近30天</el-radio-button>
                    </el-radio-group>
                </div>
            </template>
            <div class="card-content" ref="cardcontent">
                <ChartMap class="chart-normal" ref="chart"></ChartMap>
            </div>
        </Card>
    </div>
</template>
<script>
export default {
    name: "shop",
    components: {},
};
</script>
